import {
  GET_USERS_FAILD,
  GET_USERS_LOADING,
  GET_USERS_REMOVE,
  GET_USERS_SUCCESS,
} from "../types";

const initialState = {
  loading: false,
  error: null,
  users: null,
};

export const getUsersReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_USERS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: action.payload,
        error: null,
      };
    case GET_USERS_FAILD:
      return {
        ...state,
        loading: false,
        users: null,
        error: action.error,
      };
    case GET_USERS_REMOVE:
      return initialState;

    default:
      return state;
  }
};
